import React from "react";
import Social from "./Social";
import "./home.css";
import Data from "./Data";
import ScrollDown from "./ScrollDown";

const HOME_IMAGE =
  "https://res.cloudinary.com/dueeb3teu/image/upload/v1769545093/ChatGPT_Image_Jan_13_2026_06_15_08_PM_dwpgo6.png";

const Home = () => {
  return (
    <section className="home section" id="home">
      <div className="homeContainer container grid">
        <div className="homeContent grid">
          <Social />

          <div
            className="homeImg"
            style={{ "--home-img": `url("${HOME_IMAGE}")` }}
            role="img"
            aria-label="Portrait of Unique Olga"
          />

          <Data />
        </div>

        <ScrollDown />
      </div>
    </section>
  );
};

export default Home;
